export const TRIAL_EXTENSION_COUNT = {
    NO_EXTENSION: 0,
    FIRST_EXTENSION: 1,
    SECOND_EXTENSION: 2,
}
